import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  link: {
    display: 'flex',
    alignItems: 'center'
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&>figure': {
      width: 'auto !important',
    }
  }
}))
